import styled from 'styled-components';

export const MobileDropdownMenuSubSectionContainer = styled.li`
    padding-top: 20px;
`;
